import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.scss';

const MobileButtonFooter = ({ children, wrapperStyle }) => {
  const wrapperClasses = cn(styles.wrapper, {
    [wrapperStyle]: !!wrapperStyle,
  });
  return (
    <div className={wrapperClasses}>
      <div className={styles.children}>{children}</div>
    </div>
  );
};

MobileButtonFooter.propTypes = {
  children: PropTypes.node,
  wrapperStyle: PropTypes.string,
};

MobileButtonFooter.defaultProps = { children: <div /> };

export default MobileButtonFooter;
